/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getOrCreateTransactionReference} from '../api'

 export const useQueryGetOrCreateTransactionReference = createReactQueryHook('getOrCreateTransactionReference', getOrCreateTransactionReference)
